import React from 'react';
import { Icon } from 'semantic-ui-react';
import './Landing.css';

const QuestionsSection = () => {
  return (
    <div style={{ padding: '0 20px' }}>
      <div className="questions-section">
        <h2 className="questions-title">Questions?</h2>
        <p className="questions-subtitle">
          Get in touch for more information about games and results.
        </p>
        <a href="mailto:donalireland@gmail.com" className="questions-email">
          <Icon name="mail" />
          donalireland@gmail.com
        </a>
      </div>
    </div>
  );
};

export default QuestionsSection;
